import { FoodsIcon } from "@foodpilot/foods";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ActiveOrganizationContextHeader } from "src/components/ActiveOrganizationContextHeader";

export const Header = () => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <ActiveOrganizationContextHeader
            sx={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                [theme.breakpoints.down("md")]: {
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "0.5rem",
                    width: "100%",
                    paddingTop: 0,
                },
            }}
            title={
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "1rem",
                        [theme.breakpoints.down("md")]: {
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "0.5rem",
                        },
                    }}
                >
                    <Box
                        sx={{
                            [theme.breakpoints.down("md")]: {
                                display: "none",
                            },
                        }}
                    >
                        <FoodsIcon icon="trajectory" size={8} />
                    </Box>
                    <Typography
                        variant="h1"
                        sx={{
                            [theme.breakpoints.down("md")]: {
                                textAlign: "center",
                                fontSize: "1.5rem",
                            },
                        }}
                    >
                        {`${t("page.trajectory.title")}`}
                    </Typography>
                </Box>
            }
        />
    );
};
